import React from "react";

const EditorLayout = ({ children }) => (
  <div className="editor-layout">
    {children}
  </div>
);

export default EditorLayout;
